import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import type { EligibilityFormInterface } from 'types';

export const eligibilityDefaultValues: EligibilityFormInterface = {
    country: '',
    program_name: '',
    candidate_id: '',
    enhanced_with_job_offers: false,
    enhanced_language: false,
};

export const getEligibilityInitialValues = (
    candidateId: string,
    country = ''
): EligibilityFormInterface => ({
    ...eligibilityDefaultValues,
    candidate_id: candidateId,
    country,
});

export const eligibilityValidationSchema = Yup.object({
    country: validateField(ValidationType.STRING),
    program_name: validateField(ValidationType.STRING),
    candidate_id: validateField(ValidationType.STRING, false),
    enhanced_with_job_offers: validateField(ValidationType.BOOLEAN_VALUE, false),
    enhanced_language: validateField(ValidationType.BOOLEAN_VALUE, false),
});
